// extracted by mini-css-extract-plugin
module.exports = {"root":"tickets-page_root__amtVO","cards":"tickets-page_cards__VEr_i"};